/* eslint-disable import/no-mutable-exports */
/* eslint-disable */
import { initializeApp, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import {
  getDatabase,
} from 'firebase/database';
// import { getPerformance } from 'firebase/performance';
import { getRemoteConfig } from 'firebase/remote-config';

import { getCurrentOrganization } from './helpers';

function getFirebaseConfig() {
  const firebaseConfigNextIas = {
    apiKey: 'AIzaSyAQySQVZalhjb0V2yLJE6vMe8B6BNEOZ2E',
    authDomain: 'mynextias.firebaseapp.com',
    databaseURL: 'https://mynextias.firebaseio.com',
    projectId: 'mynextias',
    storageBucket: 'mynextias.appspot.com',
    messagingSenderId: '633057714702',
    appId: '1:633057714702:web:9f056dce1bf78d8ec0125f',
    measurementId: 'G-WY0BJW4DZP',
  };

  const firebaseConfigTestingExam = {
    apiKey: 'AIzaSyCftCPJ52_5LAb_rH3to01KhPN2cLT-qos',
    authDomain: 'testing-exam-6d784.firebaseapp.com',
    projectId: 'testing-exam-6d784',
    storageBucket: 'testing-exam-6d784.firebasestorage.app',
    messagingSenderId: '331181235162',
    appId: '1:331181235162:web:767f4ec7e96b0d1586fee3',
    measurementId: 'G-5Y9425T26F',
  };

  const firebaseConfigMEP = {
    apiKey: 'AIzaSyAUBtI_NwFEf_dB3stQa1s5i8atGDZY8EY',
    authDomain: 'madeeasyprime-ddaa0.firebaseapp.com',
    databaseURL: 'https://madeeasyprime-ddaa0.firebaseio.com',
    projectId: 'madeeasyprime-ddaa0',
    storageBucket: 'madeeasyprime-ddaa0.appspot.com',
    messagingSenderId: '141035980421',
    appId: '1:141035980421:web:07fb3d3ca659089b398bec',
    measurementId: 'G-K7QGL9DSNP',
  };

  const firebaseConfigMeniit = {
    apiKey: 'AIzaSyAXwqPDCCVRfuZKplYqS4PoMKlWbqQmfS8',
    authDomain: 'meniit-39e5b.firebaseapp.com',
    databaseURL: 'https://meniit-39e5b-default-rtdb.asia-southeast1.firebasedatabase.app',
    projectId: 'meniit-39e5b',
    storageBucket: 'meniit-39e5b.firebasestorage.app',
    messagingSenderId: '707920627232',
    appId: '1:707920627232:web:8edbe06bd71a648b495e45',
    measurementId: 'G-2TZ8SEZGQS',
  };
  let firebaseConfig = {};
  const orgDetails = getCurrentOrganization();
  console.log('orgDetails', orgDetails);
  firebaseConfig = firebaseConfigNextIas;

  if (orgDetails.organizationName === 'nextias') {
    firebaseConfig = firebaseConfigNextIas;
  } else if (orgDetails.organizationName === 'madeasy' || orgDetails.organizationName === 'madeeasyprime') {
    firebaseConfig = firebaseConfigMEP;
    // firebaseConfig = firebaseConfigNextIas;
  } else if (orgDetails.organizationName === 'meniit') {
    firebaseConfig = firebaseConfigMeniit;
  } else if (orgDetails.organizationName === 'testing') {
    firebaseConfig = firebaseConfigTestingExam;
  }
  return firebaseConfig;
}

function createFirebaseApp() {
  if (typeof window !== 'undefined') {
    const config = getFirebaseConfig();
    return initializeApp(config);
  }
  return getApp(); // If already initialized, use that one
}

// Services that are safe to run in both server and client contexts
export let auth = null;
export let database = null;
// The below services should only be called in a browser environment
// because they rely on `window` or other browser-only APIs.

export let analytics = null;
// export let performance = null;
export let remoteConfig = null;

if (typeof window !== 'undefined') {
  const firebaseApp = createFirebaseApp();
  database = getDatabase(firebaseApp);
  auth = getAuth(firebaseApp);
  analytics = getAnalytics(firebaseApp);
  // performance = getPerformance(firebaseApp);
  remoteConfig = getRemoteConfig(firebaseApp);

  // Example remote config settings
  remoteConfig.settings = {
    // minimumFetchIntervalMillis: 3600000, // Only for demonstration
    minimumFetchIntervalMillis: 360000,
  };
}
